import { useState } from 'react';
import { MenuViews } from '@/Models/ProfileMenu';

const useProfileMenuButton = () => {
    const [currentView, setCurrentView] = useState<MenuViews>(MenuViews.Main);
    const [open, setOpen] = useState(false);

    const handleOpenChange = (next: boolean) => {
        setOpen(next);
        if (next) {
            setCurrentView(MenuViews.Main);
        }
    };

    return {
        open,
        handleOpenChange,
        currentView,
        setCurrentView,
    };
};

export default useProfileMenuButton;
